export default __webpack_public_path__ + "static/img_13-424641bdff8e6641099c74ddd89249a5.png";